import { Box, Container, Flex, Heading, Text, Button, useColorModeValue } from '@chakra-ui/react';
import fondoPrincipal from '../assets/images/fondo_principal.webp';

function HeroSection() {
  const overlayGradient = useColorModeValue(
    'linear(to-b, rgba(248, 250, 252, 0.3), rgba(248, 250, 252, 0.9))',
    'linear(to-b, rgba(23, 31, 57, 0.4), rgba(12, 12, 24, 0.85))'
  );
  const darkOverlay = useColorModeValue('rgba(0, 0, 0, 0.3)', 'rgba(0, 0, 0, 0.68)');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const titleColor = useColorModeValue('brand.600', 'brand.600');
  return (
    <Box
      id="inicio"
      as="section"
      position="relative"
      minH="calc(100vh - 127px)"
      w="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      {/* Background Image with Blur */}
      <Box
        position="absolute"
        inset={0}
        bgImage={`url(${fondoPrincipal})`}
        bgSize="cover"
        bgPosition="center"
        filter="blur(4px)"
        transform="scale(1.02)"
        zIndex={0}
      />

      {/* Dark Overlay */}
      <Box
        position="absolute"
        inset={0}
        bg={darkOverlay}
        zIndex={1}
      />

      {/* Gradient Overlay */}
      <Box
        position="absolute"
        inset={0}
        bgGradient={overlayGradient}
        zIndex={2}
      />

      {/* Content */}
      <Container maxW="1120px" position="relative" zIndex={3}>
        <Flex
          direction="column"
          align="center"
          justify="center"
          textAlign="center"
          px={4}
          gap={6}
        >
          

          {/* Main Heading */}
          <Heading
            as="h1"
            fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
            fontWeight="700"
            color={titleColor}
            lineHeight="1.2"
          >
            IMPORTAMOS LO QUE NECESITES,
            <br />
            <Text as="span" color={titleColor}>
              DESDE CUALQUIER PARTE DEL MUNDO.
            </Text>
          </Heading>

          {/* Subtitle */}
          <Text
            fontSize={{ base: 'lg', md: 'xl' }}
            color={subtitleColor}
            maxW="900px"
            textAlign="center"
            letterSpacing="wide"
            lineHeight="tall"
            pb={3}
          >
            Desde maquinaria pesada y contenedores especializados, hasta paneles solares y productos a medida. Nos encargamos de todo el proceso.
          </Text>

          {/* CTA Button */}
          <Button
            as="a"
            href="#contacto"
            variant="primary"
            size="lg"
            px={8}
            py={6}
            fontSize="md"
          >
            Cotiza tu importación
          </Button>
        </Flex>
      </Container>
    </Box>
  );
}

export default HeroSection;
